import OptionalTag from "../../common/OptionalTag";

const ProgramJourneyTitle = ({ program }) => {
  return (
    <div className="edexlms-page-title flex align-items-center gap-2">
      <span>{program?.learningPathway?.name || ""}</span>
      {(program?.isOptional && <OptionalTag />) || null}
    </div>
  );
};

export default ProgramJourneyTitle;
